module.exports = __webpack_public_path__ + "img/1.94211e37.jpg";